import { Helmet } from 'react-helmet-async';
import {
  PageTitleWrapper,
  PageHeader,
  showErrorMessage,
  Button,
} from '../../shared/components/index';
import {
  Grid,
  Container,
} from '@mui/material';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { findExpencesByTenantId, findTransactionByTenantId } from './services/reportManagement.service';
import * as userEvent from './services/reportManagement.service';
import { selectUserState } from 'src/auth/login/services/userSlice';
import { useTranslation } from 'react-i18next';
import {
  I18N,
} from '../../shared/constants/constants';
import * as ROUTES from '../../shared/constants/routes';
import { CustomTabs, TabType } from 'src/shared/components/tabs/Tabs';
import { DeliverOrder } from './components/DeliverOrder';
import * as bookingService from '../BookingManagement/services/bookingManagement.service';
import { getTenantBookingData } from '../BookingManagement/services/bookingManagement.service';
import { PastBooking } from './components/PastBooking';
import { Statement } from './components/Statement';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import SyncTwoToneIcon from '@mui/icons-material/SyncTwoTone';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useReactToPrint } from 'react-to-print';

const ReportManagement = () => {
  const { t } = useTranslation(I18N.DEFAULT);
  const dispatch = useDispatch<any>();
  const {
    transactions,
    isError,
    errorMessage,
  } = useSelector(userEvent.selectorReportManagementState);
  const {
    bookingData,
  } = useSelector(bookingService.selectorBookingManagementState);
  const { selectedOrganization } = useSelector(selectUserState);
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [breadcrumbsHeading, setBreadcrumbsHeading] = useState(t('report.report'));
  const [headerSubtitle, setHeaderSubtitle] = useState(`${t('report.list-all-report-label')} ${selectedOrganization.tenantName}`);
  const [bookingList, setBookingList] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [activeTabId, setActiveTabId] = useState(0);
  const [startDate, setStartDate] = useState<Dayjs | null>(dayjs(new Date()).hour(0).minute(0).second(0).millisecond(0).subtract(1, 'M'));
  const [endDate, setEndDate] = useState<Dayjs | null>(dayjs(new Date()).hour(23).minute(59).second(59).millisecond(999));
  const [memoStartDate, setMemoStartDate] = useState<Dayjs | null>(dayjs(new Date()).hour(0).minute(0).second(0).millisecond(0));

  const fetchRefreshDate = () => {
    if (activeTabId === 0) {
      dispatch(findTransactionByTenantId({
        tenantId: selectedOrganization.id, startDate,
        endDate
      }));
    } else if (activeTabId === 1) {
      dispatch(getTenantBookingData({
        tenantId: selectedOrganization.id, startDate: memoStartDate,
        endDate,
        isBookingAsset: true,
      }));
    } else if (activeTabId === 2) {
      dispatch(getTenantBookingData({
        tenantId: selectedOrganization.id, isPast: true, startDate,
        endDate
      }));
    }
  };

  useEffect(() => {
    const breadcrumb = [
      {
        name: t('organization'),
        route: `${ROUTES.ADMIN_LOGIN}${ROUTES.ORGANIZATION}`
      },
      {
        name: selectedOrganization.tenantName,
        route: ROUTES.USER_MANAGEMENT
      }
    ];
    setBreadcrumbs(breadcrumb);
    fetchRefreshDate();
  }, []);

  useEffect(() => {
    fetchRefreshDate();
  }, [activeTabId]);

  useEffect(() => {
    if (isError) {
      dispatch(userEvent.setIsError(false));
      if (errorMessage !== '') {
        return showErrorMessage(errorMessage, {
          theme: 'colored',
          position: 'top-right',
          autoClose: 5000
        });
      }
    }
  }, [isError]);

  useEffect(() => {
    setBookingList(bookingData);
  }, [bookingData]);

  useEffect(() => {
    setTransactionsList(transactions);
  }, [transactions]);

  const contentToPrint: MutableRefObject<any> = useRef(null);
  const handlePrintButtonClick = useReactToPrint({
    documentTitle: "Delivary order Details",
    onBeforePrint: () => console.log("before printing..."),
    onAfterPrint: () => console.log("after printing..."),
    removeAfterPrint: true,
  })

  const allTabs: TabType[] = [
    {
      value: 0,
      label: `${t('report.statement.statement')}`,
      component: (
        <Grid>
          <Statement transactions={transactions} startDate={startDate} endDate={endDate}></Statement>
        </Grid>
      )
    },
    {
      value: 1,
      label: `${t('report.deliverorder')}`,
      component: (
        <Grid>
          <DeliverOrder company={selectedOrganization} bookingList={bookingList} contentToPrint={contentToPrint} startDate={memoStartDate} endDate={endDate}/>
        </Grid>
      )
    },
    {
      value: 2,
      label: `${t('report.pastbooking')}`,
      component: (
        <Grid>
          <PastBooking pastBookingData={bookingList} />
        </Grid>
      )
    },
  ];

  const handleTabChange = (newValue: number) => {
    setActiveTabId(newValue);
  };

  return (
    <>
      <Helmet>
        <title>BookingDLiteExpence</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader
          breadcrumbs={breadcrumbs}
          heading={breadcrumbsHeading}
          subHeading={headerSubtitle}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker sx={{ width: 150 }} label="Start date"
              value={activeTabId !== 1 ? startDate : memoStartDate}
              format='DD/MM/YYYY'
              onChange={(newValue) => {
                newValue = newValue.hour(0).minute(0).second(0).millisecond(0);
                if(activeTabId !== 1){
                  setStartDate(newValue)
                } else {
                  setMemoStartDate(newValue);
                }
              }} />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker sx={{ width: 150 }} label="End date"
              value={endDate}
              format='DD/MM/YYYY'
              onChange={(newValue) => {
                newValue = newValue.hour(23).minute(59).second(59).millisecond(999);
                setEndDate(newValue)
              }} />
          </LocalizationProvider>
          <Button
            size={'small'}
            sx={{ pt: 1, pb: 1 }}
            variant={'contained'}
            className="letter-spacing"
            startIcon={<SyncTwoToneIcon fontSize="small" />}
            onClick={() => fetchRefreshDate()}
          >
            {t('sync-data')}
          </Button>
          {activeTabId === 1 && (
            <Button
              size={'small'}
              sx={{ pt: 1, pb: 1 }}
              className="letter-spacing"
              variant={'contained'}
              btnText={t('booking.print')}
              startIcon={<AddTwoToneIcon fontSize="small" />}
              onClick=
              {() => {
                handlePrintButtonClick(null, () => contentToPrint.current);
              }}
            >
              {t('print')}
            </Button>
          )}
        </PageHeader>
      </PageTitleWrapper>

      <Container maxWidth="lg">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <CustomTabs
            tabList={
              allTabs
            }
            handleTabChange={handleTabChange}
            activeTab={activeTabId}
          >
          </CustomTabs>
        </Grid>
      </Container >
    </>
  );
};
export default ReportManagement;
